import { Routes } from '@angular/router';
import { AuthGuard } from './auth/guards/auth.guard';
import { NoAuthGuard } from './auth/guards/no-auth.guard';

/**
 * Route Classification:
 *
 *  Truly public     — No guard. Anyone can land here, session state is irrelevant.
 *                        The component itself handles its own auth (e.g. token in URL).
 *
 *  Auth-page public — NoAuthGuard. Unauthenticated users can enter; authenticated
 *                        users are redirected to /layout.
 *
 *  Protected        — AuthGuard. Authenticated users only; others go to /login.
 */

export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'login',
  },
  // ── Auth-page public routes (NoAuthGuard) ──────────────────────────────
  {
    path: 'login',
    canActivate: [NoAuthGuard],
    loadComponent: () =>
      import('./auth/login/login.component').then((m) => m.LoginComponent),
  },
  {
    path: 'otp',
    canActivate: [NoAuthGuard],
    loadComponent: () =>
      import('./auth/otp/otp.component').then((m) => m.OtpComponent),
  },
  {
    path: 'forgot-password',

    loadComponent: () =>
      import('./auth/forget-pswd/forget-pswd.component').then(
        (m) => m.ForgetPswdComponent
      ),
  },
  {
    path: 'reset-password/:token',
    
    loadComponent: () =>
      import('./auth/reset-password/reset-password.component').then(
        (m) => m.ResetPasswordComponent
      ),
  },
  // ── Truly public routes (NO guard) ─────────────────────────────────────
  // These routes are accessible by anyone regardless of session state.
  // Do NOT add NoAuthGuard here — that guard calls ensureSessionState() which
  // sets sessionValid$ = false, and that false state can leak into other guards.
  {
    path: 'pda-disburesement/approval/:token',
    loadComponent: () =>
      import('./components/client-approval-form/client-approval-form.component').then(
        (m) => m.ClientApprovalFormComponent
      )
  },
  {
    path: 'pda-disburesement/:token',
    loadComponent: () =>
      import('./auth/login/login.component').then((m) => m.LoginComponent),
    data: { isDisbursement: true }
  },
  {
    path: 'port-agent-form',
    loadComponent: () =>
      import('./components/port-agent-form/port-agent-form.component').then(
        (m) => m.PortAgentFormComponent
      )
  },
  {
    path: 'submit/success',
    loadComponent: () =>
      import('./components/port-agent-form/pa-form-submit-success-page/pa-form-submit-success-page.component').then((m) => m.PaFormSubmitSuccessPageComponent),
  },
  {
    path: 'pdfa',
    loadChildren: () =>
      import('./pages/pdfa/pdfa.routes').then((m) => m.PdfaRoutes),
  },

  // ── Protected routes (AuthGuard) ────────────────────────────────────────
  {
    path: 'layout',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./shared/layout/layout.routes').then((m) => m.LayoutRoutes),
  }
];
